import { UpsPackageStatus, UpsShipmentStatus } from '../enums/ups-shipment-status.enum';
import { emptyUpsRateBreakdown } from '../models/ups-rate-breakdown.model';
import { UpsShipment } from '../models/ups-shipment.model';

/**
 * The shipment marked Voided — status + every package flipped to Voided. Persist this only
 * AFTER UPS has confirmed the void (or the non-production bypass applied), never before.
 */
export function asVoidedUpsShipment(shipment: UpsShipment, userId: string): UpsShipment {
    return {
        ...shipment,
        status: UpsShipmentStatus.Voided,
        packages: (shipment.packages ?? []).map(p => ({ ...p, status: UpsPackageStatus.Voided })),
        updatedOn: new Date(),
        updatedById: userId,
    };
}

/**
 * A fresh Draft copy of a processed shipment: same addresses/packages/service/billing, the
 * supplied new id, and all UPS results cleared (no tracking, labels, cost, or package status)
 * so it re-processes into brand-new labels. `supersedesId` records the shipment this clone
 * replaces, so the void & clone chain can be back-tracked to the original.
 */
export function asDraftUpsClone(shipment: UpsShipment, userId: string, newId: string): UpsShipment {
    const now = new Date();
    return {
        ...shipment,
        id: newId,
        status: UpsShipmentStatus.Draft,
        supersedesId: shipment.id,
        shipmentIdentificationNumber: '',
        packages: (shipment.packages ?? []).map(p => ({ ...p, trackingNumber: '', labelZpl: '', status: '', exceptionDetail: '' })),
        publishedCost: '',
        negotiatedCost: '',
        publishedBreakdown: emptyUpsRateBreakdown(),
        negotiatedBreakdown: emptyUpsRateBreakdown(),
        processedOn: null,
        lastTrackedOn: null,
        createdOn: now,
        createdById: userId,
        updatedOn: now,
        updatedById: userId,
    };
}
